import BenAppSpinner from "./ben-app-spinner";

export default BenAppSpinner;
